export const BRAVO_MODAL_ID = 'BRAVO_MODAL_ID';
export const NOBONUS_MODAL_ID = 'NOBONUS_MODAL_ID';
export const INSTRUCTIONS_MODAL_ID = 'INSTRUCTIONS_MODAL_ID';
export const TERMS_MODAL_ID = 'TERMS_MODAL_ID';
export const ERROR_MODAL_ID = 'ERROR_MODAL_ID';
